import { defineComponent } from 'vue';
import { defineStore, mapStores } from 'pinia';
import defaultAvatar from '@/assets/logo.jpg';

export const useUserStore = defineStore('user', {
  state: () => ({
    lang: localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : 'en',
    user: JSON.parse(localStorage.getItem('user')) || null,
    localeMessages: JSON.parse(localStorage.getItem('localeMessages')) || {},
    token: localStorage.getItem('token') || null,
  }),
  actions: {
    setLanguage(lang) {
      this.lang = lang;
      localStorage.setItem('lang', JSON.stringify(lang));
    },
    setUser(userData) {
      this.user = userData;
      this.user.picture = this.user.picture ? this.user.picture : defaultAvatar;
      localStorage.setItem('user', JSON.stringify(userData));
    },
    setToken(token) {
      this.token = token;
      if (token) {
        localStorage.setItem('token', token);
      } else {
        localStorage.removeItem('token');
      }
    },
    logout() {
      this.user = null;
      this.token = null;
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.setItem('lang', JSON.stringify(this.lang));
    },
    setLocaleMessages(lang, messages) {
      this.localeMessages[lang] = messages;
      localStorage.setItem('localeMessages', JSON.stringify(this.localeMessages));
    },
  },
});

export default defineComponent({
  computed: {
    ...mapStores(useUserStore),
  },
});
